import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import ReviewApi from "../../apis/review.api";
import { DATE_FORMAT, PAGE_NO, PAGE_SIZE } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
import { MORE, THIS_IS_THE_LAST_REVIEW } from "../../text-data";
import GeneralReviewNoData from "./GeneralReviewNoData";
import ReviewBox from "./ReviewBox";
import {
  kIN_1_MONTH,
  kIN_1_WEEKS,
  kIN_3_MONTHS,
  kYESTERDAY,
} from "./ReviewStatusKeys";
import SpecialReviewNoData from "./SpecialReviewNoData";

const yesterday = moment(new Date(moment().subtract(1, "d"))).format(
  DATE_FORMAT.YYYYMMDD
);

const defaultParams = {
  search_important_yn: "N",
  search_start_dt: yesterday,
  search_end_dt: yesterday,
  page_no: PAGE_NO,
  page_size: PAGE_SIZE,
  search_comment_reg_status_code: null,
};

export default function ReviewList() {
  const location = useLocation();
  const isSpecial = location.pathname.includes("special");
  const [reviewList, setReviewList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalCount, setTotalCount] = useState(0);

  const [params, setParams] = useState(defaultParams);
  const { ceoInfo } = useAuth();
  const [postAfterDays, setPostAfterDays] = useState(0);
  const [additionCommentList, setAdditionCommentList] = useState([]);
  const getReview = async (listParams) => {
    const res = await ReviewApi.get(listParams ?? params);
    if (res.data.data.review_list) {
      setTotalCount(res.data.data.total_cnt);
      setReviewList(res.data.data.review_list);
    }
  };

  const getFilterTime = (type) => {
    const currentDate = moment();
    let search_start_dt, search_end_dt;

    if (type === kYESTERDAY) {
      search_start_dt = yesterday;
      search_end_dt = yesterday;
    } else if (type === kIN_1_WEEKS) {
      const startOfWeek = currentDate.clone().subtract(6, "days");
      const endOfWeek = currentDate.clone();
      search_start_dt = startOfWeek.format(DATE_FORMAT.YYYYMMDD);
      search_end_dt = endOfWeek.format(DATE_FORMAT.YYYYMMDD);
    } else if (type === kIN_1_MONTH) {
      search_start_dt = currentDate
        .clone()
        .subtract(1,"month")
        .format(DATE_FORMAT.YYYYMMDD);
      search_end_dt = currentDate
        .clone()
        .format(DATE_FORMAT.YYYYMMDD);
    } else if (type === kIN_3_MONTHS) {
      const startOfThreeMonthsAgo = currentDate
        .clone()
        .subtract(3, "months")
        .startOf("month");
      search_start_dt = startOfThreeMonthsAgo.format(DATE_FORMAT.YYYYMMDD);
      search_end_dt = currentDate.clone().format(DATE_FORMAT.YYYYMMDD);
    }

    return {
      search_start_dt,
      search_end_dt,
    };
  };

  const handleGetReviewByParams = async () => {
    let statusCode = null;
    let search_start_dt = null;
    let search_end_dt = null;

    if (searchParams.get("search_comment_reg_status_code")) {
      statusCode = [searchParams.get("search_comment_reg_status_code")];
    }
    if (searchParams.get("time")) {
      const dateTime = getFilterTime(searchParams.get("time"));
      search_start_dt = dateTime?.search_start_dt ?? null;
      search_end_dt = dateTime?.search_end_dt ?? null;
    }
    const filterParams = {
      ...params,
      search_start_dt,
      search_end_dt,
      search_comment_reg_status_code: statusCode,
      search_important_yn: isSpecial ? "Y" : 'N'
    }

    await getReview(filterParams);

    setTimeout(() => {
      setParams(filterParams);
    }, 500);
  };

  useEffect(() => {
    handleGetReviewByParams();
  }, [searchParams, isSpecial]);

  const onGetMoreReview = async () => {
    const res = await ReviewApi.get({
      ...params,
      page_no: parseFloat(params.page_no) + 1,
    });

    setParams({
      ...params,
      page_no: parseFloat(params.page_no) + 1,
    });

    const concatReviews = reviewList.concat(res.data.data.review_list);
    if (res.data.data.review_list) {
      setTotalCount(res.data.data.total_cnt);
      setReviewList(concatReviews);
    }
  };


  const getSavedSetting = async () => {
    if (ceoInfo?.shop_idx) {
      const { data } = await ReviewApi.getSavedSetting(ceoInfo?.shop_idx);
      if (data.data) {
        setPostAfterDays(data.data.post_after_days);
      }
    }
  };
  const getAdditionContent = async () => {
    const res = await ReviewApi.getAdditionContent(ceoInfo.shop_idx);
    if (res.data?.data) {
      setAdditionCommentList(res.data.data);
    }
  }
  useEffect(() => {
    getSavedSetting();
    getAdditionContent();
  }, []);

  if (!reviewList.length) {
    if (isSpecial) {
      return <SpecialReviewNoData />;
    }
    return <GeneralReviewNoData />;
  }

  return (
    <div className="flex flex-col gap-6 mb-8 justify-center items-center mx-2 pb-20">
      {reviewList.map((review, index) => (
        <ReviewBox
          refreshReview={handleGetReviewByParams}
          postAfterDays={postAfterDays}
          isNotUsePostDay={postAfterDays === 0 ? true : false}
          key={index}
          additionCommentList ={additionCommentList}
          {...review}
        />
      ))}
      {reviewList.length < totalCount && (
        <button
          className="py-2 px-4 w-fit block rounded-full"
          style={{ border: "1px solid #CDD1DB" }}
          onClick={onGetMoreReview}
        >
          <b>+{MORE}</b>
        </button>
      )}

      {reviewList.length >= totalCount && (
        <span style={{ color: "#B7BDCA" }} className="text-sm font-bold">
          {THIS_IS_THE_LAST_REVIEW}
        </span>
      )}
    </div>
  );
}
